exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".catalog {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.catalog__filter {\n  padding: 10px 0;\n}\n.catalog .catThumb img {\n  height: 100px;\n}\n.catalog .url-image-cat {\n  margin-bottom: 10px;\n}\n.catalog .h4-cat {\n  margin-bottom: 20px;\n}\n.catalog .pt30 {\n  padding-top: 30px;\n}\n.catalog .is-current > .el-tree-node__content {\n  background-color: #F5F7FA;\n}\n.catalog .mb30 {\n  margin-bottom: 30px;\n}", ""]);

// exports
